import AWN from 'awesome-notifications';

const btnCart = document.querySelector('.js-btn-cart');
const buyBox = document.querySelector('.js-buy-box');

// Set global options
const options =
{
  icons: { enabled: false },
  maxNotifications: 3,
};

if (buyBox)
  options.position = 'bottom-center-buybox';
else
  options.position = 'bottom-center';

window.notifier = new AWN(options); // Initialize instance of AWN

if (btnCart)
{
  // Set custom options
  const cartOptions = {
    durations: { success: 4000 },
    icons: {
      prefix: "<img src='",
      success: '/dist/images/cart-white.svg',
      suffix: "'/>",
      enabled: true,
    },
    labels: { success: 'Produkt byl vložen do košíku' },
  };

  btnCart.addEventListener('click', () =>
  {
    notifier.success('<p class="awn-toast-description">Description</p><a href="#" class="awn-toast-link">Zobrazit košík</a>', cartOptions);
  });
}
